module.exports = __webpack_public_path__ + "static/media/WITJSFTKC1.1819c829.png";